import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionTag, SectionTitle } from "./shared";
import { IMG } from "../data/site";
import { Check } from "lucide-react";

const SERVICES = [
  "Inventory discovery", "Project comparison", "Unit selection", "Price comparison",
  "Site visits", "Resale evaluation", "Documentation guidance", "RERA verification",
  "Negotiation assistance", "Investment analysis", "Post-sale support",
];

export function Advisory({ onAdvisor }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="advisory" ref={ref} className="relative py-28 lg:py-40 overflow-hidden bg-[#0A0A0A]" data-testid="advisory-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <SectionTag>Property Advisory</SectionTag>
          <SectionTitle className="text-4xl sm:text-5xl">
            Don&rsquo;t Just Buy Property.<br />
            <span className="text-gold-gradient italic">Choose Your Position.</span>
          </SectionTitle>
          <Reveal delay={0.15}>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3.5 mt-10 mb-10" data-testid="advisory-services">
              {SERVICES.map((s) => (
                <div key={s} className="flex items-center gap-3">
                  <span className="flex items-center justify-center w-5 h-5 rounded-full border border-[#D4AF37]/50 shrink-0">
                    <Check size={11} className="text-[#D4AF37]" />
                  </span>
                  <span className="text-[13px] text-[#A1A1AA]">{s}</span>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <button
              data-testid="advisory-cta-btn"
              onClick={onAdvisor}
              className="px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] bg-gradient-to-r from-[#C5A059] to-[#D4AF37] text-black hover:from-[#D4AF37] hover:to-[#F3E5AB] transition-colors rounded-[2px]"
            >
              Speak with a Radiance Advisor
            </button>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative h-[420px] lg:h-[560px] overflow-hidden rounded-[2px] border border-[#D4AF37]/20">
            <motion.img
              src={IMG.advisor} alt="Radiance property advisor"
              className="w-full h-[125%] object-cover object-top"
              style={{ y, filter: "grayscale(1) contrast(1.08) brightness(0.9)" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-black/30" />
            <div className="absolute bottom-0 inset-x-0 p-7">
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-2">The Advisory Desk</p>
              <p className="font-serif-lux text-2xl text-[#F5F5F0] leading-snug">&ldquo;We study the corridor so you can buy with conviction.&rdquo;</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
